import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const DashboardApi = createApi({
  reducerPath: "DashboardApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["DASHBOARD"],
  endpoints: (build) => ({
    getDashboard: build.query({
      query: ({
        includeStats = true,
        includeBots = true,
        includeActivity = true,
        botsPage = 1,
        botsLimit = 10,
        activityLimit = 20,
        botStatus,
      } = {}) => {
        const params = new URLSearchParams({
          includeStats: includeStats.toString(),
          includeBots: includeBots.toString(),
          includeActivity: includeActivity.toString(),
          botsPage: botsPage.toString(),
          botsLimit: botsLimit.toString(),
          activityLimit: activityLimit.toString(),
        });

        if (botStatus) {
          params.append("botStatus", botStatus);
        }

        return `/dashboard?${params.toString()}`;
      },
      providesTags: ["DASHBOARD"],
    }),
  }),
});

export const { useGetDashboardQuery } = DashboardApi;
